import AmazonAdsService from 'app/lib/services/providers/AmazonAdsService';
import { getInnerError, renderLoader } from 'app/lib/utils/adaya/AdayaUtils';
import axios from 'axios';
import Button from 'components/shared/app/Button';
import Spinner from 'components/shared/app/Spinner';
import Config from 'lib/Config';
import GoogleService from 'lib/services/providers/GoogleService';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import './style.scss';

const AmazonAdsCallback = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [callbackData, setCallbackData] = useState({});
    const [customerValue, setCustomerValue] = React.useState('');
    const [dataSaved, setDataSaved] = useState(false);

    const handleChange = (event) => {
        //console.log(event.target);
        let profile_id;
        // console.log('HELLO' + callbackData.profiles);
        callbackData.profiles.map((x,i) => {
           
            if(x.accountInfo.name == event.target.value)
                profile_id = x.profileId;
        })
        setCustomerValue(profile_id);
    };

    const handleClick = async (event) => {
        try {
            setLoading(true);
            setError(undefined);

            // console.log(`callbackData`, callbackData);

            let r = await AmazonAdsService.connectAmazonAccount({
                access_token: callbackData.access_token,
                refresh_token: callbackData.refresh_token,
                profile_id: customerValue,
            });

            if (r.success) {
                await props.auth.updateUserLocal(r.user);
                setDataSaved(true);
            } else {
                setError(getInnerError(r));
            }

        } catch (e) {
            setError(getInnerError(e));
        }

        setLoading(false);
    };

    const goToAccountButton = () => {
        return (
            <Link to="/account">
                <Button round filled color="green">
                    Go To Account
                </Button>
            </Link>
        );
    };

    const profilesSelectDropdown = () => {
    

        return (
            <>
                <h5 style={{ color: '#fff', margin: '1rem' }}>Please select the Amazon Ads account:</h5>
                <select onChange={handleChange}>
                    <option>Select..</option>
                    {callbackData.profiles.map((c, i) => (
                        <option key={i} value={c.profile_id}>{c.accountInfo.name}</option>
                    ))}
                </select>{' '}
                <br />
                <Button round filled color="green" onClick={handleClick}>
                    Select Ads Account
                </Button>
            </>
        );
    };

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            let code = window.location.search;
            const r = await axios.get(`${process.env.API_URL}/amazon_ads-callback${code}`);

            console.log(r);
        
            if (r.data) {
                if (r.data.profiles.length == 0) {
                    setError('You have no eligible Amazon Ads accounts')
                }
                else
                    setCallbackData(r.data);
            } else {

                console.log(`error`, r);
                setError(
                    (r.error || r.message || 'An error occurred connecting your Amazon account.') +
                    ' Please return to the Account page and try again.');
            }
        } catch (e) {
            throw e;
        }
        setLoading(false);
    };

    const renderError = () => (
        <div className="flex-col-center error">
            <h3>Error</h3>
            <h4 dangerouslySetInnerHTML={{ __html: error }}></h4>
            <p>Please try to connect your Amazon Ads account again from the Account page.</p>
            <Link to="/account">
                <div className="button color-green filled round">Back to Account</div>
            </Link>
        </div>
    );

    return (
        <div className="google-callback-page">
            <Helmet>
                <title>{Config.SITE_TITLE_PREFIX} - Connecting Amazon Ads Account</title>
            </Helmet>

            {error ? (
                renderError()
            ) : loading ? (
                renderLoader('Connecting to Amazon Ads...')
            ) : (
                <div className="flex-col-center" style={{ marginTop: '4rem', width: '100%' }}>
                    {loading ? (
                        <Spinner message="Loading customer information..." />
                    ) : (
                        <>
                            <Helmet>
                                <title>{Config.SITE_TITLE_PREFIX} - Amazon Ads Connected</title>
                            </Helmet>
                            <h4 style={{ color: '#fff', margin: '1rem' }}>Thank you for connecting your Amazon Ads account!</h4>

                            {dataSaved ? goToAccountButton() : profilesSelectDropdown()}
                        </>
                    )}
                </div>
            )}
        </div>
    );

};

export default AmazonAdsCallback;
